export const isValidPassword = (password: string): boolean => {
  // at least 8 characters, with at least one upper and one lower case character, one number and one special character
  const re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,})(?!.*\s).{8,}$/;

  return re.test(password);
};

